import { TranslateService } from '@ngx-translate/core';
import { TraceService } from '@sentry/angular';
import { lastValueFrom } from 'rxjs';

export function appInitializerFactory(_sentry: TraceService, translate: TranslateService) {
    return () => new Promise<null>((resolve: (value: PromiseLike<null>) => void) => {
        const langToSet = 'fr';
        translate.setFallbackLang(langToSet);
        lastValueFrom(translate.use(langToSet)).catch((e) => console.error(e)).finally(() => resolve(null));
    });
}
